module.exports = __webpack_public_path__ + "img/lpatop_view.43a38e40.png";